@file:OptIn(InternalResourceApi::class)

package tfccare.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/tfccare.composeapp.generated.resources/"

@delegate:ResourceContentHash(613_081_317)
internal val Res.font.devnagri: FontResource by lazy {
      FontResource("font:devnagri", setOf(
        ResourceItem(setOf(), "${MD}font/devnagri.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("devnagri", Res.font.devnagri)
}
